"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

exports.__esModule = true;
exports.default = void 0;

var P = _interopRequireWildcard(require("@react-pdf/primitives"));

var _fns = require("@react-pdf/fns");

var NON_WRAP_TYPES = [P.Svg, P.Note, P.Image, P.Canvas];

var getWrap = function getWrap(node) {
  var _node$props;

  if (NON_WRAP_TYPES.includes(node.type)) return false;
  return (0, _fns.isNil)((_node$props = node.props) === null || _node$props === void 0 ? void 0 : _node$props.wrap) ? true : node.props.wrap;
};

var _default = getWrap;
exports.default = _default;